import { render, staticRenderFns } from "./selectModuleAndWidget.vue?vue&type=template&id=397601b5"
import script from "./selectModuleAndWidget.vue?vue&type=script&lang=js"
export * from "./selectModuleAndWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports